// @ts-nocheck
import React, { useId, useRef, useState } from "react";
import * as services from "../Services/services";
import { ok, message } from "./learningShared";

/*
 * Ask to join training — for someone Copilot signed in whom AVS OS can't match to a training record
 * (no OS contact for their email yet; copilot-api passes that refusal through as code no_learner).
 *
 * The request goes to AVS OS with the SIGNED-IN email (copilot-api ignores any other), which matches
 * the email's domain to one customer and puts it in front of that customer's training admin and CSM.
 * AVS OS only accepts it while learning.signup.domainEnabled is on; otherwise it says so and this
 * form shows that message.
 */

export default function LearningSignup() {
  const id = useId();
  const [form, setForm] = useState({ firstName: "", lastName: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [sent, setSent] = useState(false);
  const headingRef = useRef(null);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    if (!form.lastName.trim()) {
      setError("Enter your last name.");
      return;
    }
    setBusy(true);
    setError(null);
    const resp = await services.lmsSignupRequest({ firstName: form.firstName.trim(), lastName: form.lastName.trim() });
    setBusy(false);
    if (!ok(resp)) {
      setError(message(resp, "Your request couldn't be sent, please try again."));
      return;
    }
    setSent(true);
    setTimeout(() => headingRef.current?.focus(), 0);
  };

  if (sent)
    return (
      <div className="card learning-card" data-testid="learning-signup-sent">
        <div className="card-body">
          <h2 className="h6" tabIndex={-1} ref={headingRef}>
            Request sent
          </h2>
          <p className="mb-0 text-body-secondary">
            Your company's training admin will look at it. Once they approve it, your training will appear here.
          </p>
        </div>
      </div>
    );

  return (
    <form className="card learning-card" onSubmit={submit} noValidate aria-labelledby={`${id}-title`} data-testid="learning-signup-form">
      <div className="card-body">
        <h2 id={`${id}-title`} className="h6 mb-1">
          You don't have training set up yet
        </h2>
        <p className="text-body-secondary small mb-3">
          Ask to join and your company's training admin will be asked to approve you. We'll use the email you signed in with.
        </p>
        <div className="row g-2">
          <div className="col-6 col-md-4">
            <label className="form-label small" htmlFor={`${id}-first`}>
              First name
            </label>
            <input id={`${id}-first`} className="form-control form-control-sm" value={form.firstName} onChange={set("firstName")} maxLength={80} autoComplete="given-name" data-testid="learning-signup-first" />
          </div>
          <div className="col-6 col-md-4">
            <label className="form-label small" htmlFor={`${id}-last`}>
              Last name
            </label>
            <input
              id={`${id}-last`}
              className="form-control form-control-sm"
              value={form.lastName}
              onChange={set("lastName")}
              maxLength={80}
              required
              autoComplete="family-name"
              aria-invalid={error === "Enter your last name."}
              data-testid="learning-signup-last"
            />
          </div>
          <div className="col-12 col-md-4 d-flex align-items-end">
            <button type="submit" className="btn btn-primary btn-sm" disabled={busy} data-testid="learning-signup-submit">
              {busy ? "Sending…" : "Ask to join"}
            </button>
          </div>
        </div>
        {error && (
          <p className="small text-danger mt-2 mb-0" role="alert" data-testid="learning-signup-error">
            {error}
          </p>
        )}
      </div>
    </form>
  );
}
